import React from 'react'
import { Box } from '@mui/material'
import { InstallationWithoutAccess } from 'src/Libs/installations/models'
import { getEmsProductImage } from 'src/Libs/installations/utils/product-image'
import { ImageVersions } from 'src/Libs/installations/types'
import { FarmIcon } from '@e3dc-react/icons'

interface Props {
  installation: InstallationWithoutAccess
}

/**
 * Display image for the installation.
 * used in 'product type' column of the installation without access table
 */
const InstallationWithoutAccessImage: React.FC<Props> = ({ installation }) => {
  const { isFarm, emsMasterProduct } = installation
  const alt = isFarm ? 'farm-storage-icon' : 'storage-icon'

  if (isFarm)
    return (
      <Box width={35} height={35}>
        <FarmIcon />
      </Box>
    )

  return (
    <Box component="img" src={getEmsProductImage(emsMasterProduct, undefined, ImageVersions.ThreeDimensional)} alt={alt} width={35} height={35} />
  )
}

export default InstallationWithoutAccessImage
